export default __webpack_public_path__ + "static/media/안주1.4972be17.png";